import { QuoteForm } from "./QuoteForm";

export const QuoteSection = () => {
  return (
    <section
      id="quote"
      data-testid="quote-section"
      className="relative py-28 lg:py-36 bg-gradient-to-b from-black via-[#0a0a0a] to-black"
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-brand-magenta/[0.06] blur-[180px] pointer-events-none" />
      <div className="max-w-6xl mx-auto px-6 lg:px-10 relative">
        <div className="text-center mb-14">
          <p
            data-testid="quote-eyebrow"
            className="font-body text-xs uppercase tracking-[0.3em] text-brand-magenta"
          >
            [ Request a Quote ]
          </p>
          <h2
            data-testid="quote-headline"
            className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-white"
          >
            Tell Me About Your{" "}
            <span className="text-eq-gradient">Project</span>.
          </h2>
          <p className="mt-5 max-w-2xl mx-auto font-body text-white/60">
            Fill out the form and I'll respond with timing and a custom
            quote. Booking a live session? Drop the event date, and I'll
            confirm availability fast.
          </p>
        </div>
        <QuoteForm />
      </div>
    </section>
  );
};
